var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGalleryTitle = function SvgGalleryTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 22",
    style: {
      enableBackground: "new 0 0 129 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gallery",
    transform: "translate(0.000000, 1527.000000)",
    d: "M11.4-1505.5c-5.9,0-10.3-4.7-10.3-10.4s4.6-10.4,10.3-10.4 c3.6,0,6,1.2,7.6,2.9l-3.4,3.9c-0.9-1-2.5-1.7-4.2-1.7c-2.7,0-4.9,2.4-4.9,5.3c0,2.9,2.1,5.3,5.1,5.3c0.8,0,1.7-0.2,2.4-0.6v-4.7 h5.1v7.9C17.6-1506.6,15-1505.5,11.4-1505.5z M35.3-1509.8h-7.8l-1.4,3.8h-5.4l7.8-19.9h6l7.8,19.9h-5.6L35.3-1509.8z M31.5-1520.4 l-2.3,6.2h4.5L31.5-1520.4z M44.5-1525.9h5.1v15.1h9v4.8H44.5V-1525.9z M60.8-1525.9h5.1v15.1h9v4.8H60.8V-1525.9z M77.1-1525.9 h13.2v4.8h-8.1v2.6h6.9v4.8h-6.9v2.9h8.1v4.8H77.1V-1525.9z M93.1-1525.9h7.2c5.1,0,8.4,2.6,8.4,6.6c0,2.6-1.4,4.6-3.7,5.7l4.2,7.6 h-5.9l-3.4-6.6h-1.7v6.6h-5.1V-1525.9z M98.2-1521.4v4.2h2.5c1.5,0,2.6-0.9,2.6-2.2c0-1.2-1-2.1-2.6-2.1H98.2z M116.1-1512.5 l-7.2-13.4h5.7l4.2,8l4.3-8h5.4l-7.2,13.4v6.5h-5.1V-1512.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGalleryTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery_title.0f08265f.svg";
export { ForwardRef as ReactComponent };